import { Grid, IconButton, withStyles } from "@material-ui/core";
import React from "react";
import CustomSelectNew from "../../components/UpdateUi/CustomeSelect";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import DeleteIcon from "@material-ui/icons/Delete";

const SchemeChargeDetail = ({
  classes,
  viewPage,
  setChargeNatureState,
  chargeNatureState,
  valueSetState,
  minAmountState,
  setMinAmountState,
  maxAmountState,
  setMaxAmountState,
  chargeDetails,
  chargeNatureList,
  handleChange,
  groupindex,
  onClickDeleteData,
  editIndex,
  schemeChargeLength,
  editMode,
}) => {
  return (
    chargeDetails?.length > 0 &&
    chargeDetails?.map((item, index) => (
      <Grid item xs={12} sm={12} md={12} key={index} style={{ display: "flex" }}>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomSelectNew
            label="Charge Nature"
            error={chargeDetails?.[index]?.chargeNatureError}
            value={chargeDetails?.[index]?.chargeNature}
            setState={handleChange}
            data={chargeNatureList}
            setError={setChargeNatureState}
            index={index}
            groupindex={groupindex}
            type="chargeDetailsNature"
            disabled={viewPage ||  (editIndex !== groupindex && editMode &&  groupindex !== schemeChargeLength )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="Days"
            required
            error={chargeDetails?.[index]?.daysError}
            value={
              index === 0
                  ? `${index * 30 + 1}-${index * 30 + 30}`
                  : `${index * 30 + 1}-${index * 30 + 30}`
          }
            index={index}
            groupindex={groupindex}
            disabled={true}
            type="chargeDays"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="Value"
            required
            error={chargeDetails?.[index]?.valueError}
            value={chargeDetails?.[index]?.value}
            setState={handleChange}
            index={index}
            groupindex={groupindex}
            type="chargeValue"
            disabled={viewPage ||  (editIndex !== groupindex && editMode && groupindex !== schemeChargeLength)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="MinAmount"
            required
            error={chargeDetails?.[index]?.minAmountError}
            value={chargeDetails?.[index]?.minAmt}
            disabled={
                chargeDetails[index]?.chargeNature === "FLAT"
                  ? true
                  : false || viewPage ||  (editIndex !== groupindex && editMode && groupindex !== schemeChargeLength)
            }
            setState={handleChange}
            setError={setMinAmountState}
            index={index}
            groupindex={groupindex}
            type="chargeMinAmount"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="MaxAmount"
            required
            error={chargeDetails?.[index]?.maxAmountError}
            value={chargeDetails?.[index]?.maxAmt}
            disabled={
                chargeDetails[index]?.chargeNature === "FLAT"
                  ? true
                  : false || viewPage || (editIndex !== groupindex && editMode && groupindex !== schemeChargeLength)
            }
            setState={handleChange}
            setError={setMaxAmountState}
            index={index}
            groupindex={groupindex}
            type="chargeMaxAmount"
          />
        </Grid>
        {(!viewPage && chargeDetails?.length === index + 1 ) && <IconButton
          aria-label="Delete Scheme"
          style={{ padding: "0px", color: "red", marginTop: "20px" }}
          onClick={(e) => {
            e.stopPropagation();
            onClickDeleteData(index, groupindex);
          }}
          disabled={(editIndex !== groupindex && editMode && groupindex !== schemeChargeLength)}
        >
          <DeleteIcon />
        </IconButton>
}
      </Grid>
    ))
  );
};
export default SchemeChargeDetail;
